import type { AxiosError } from 'axios'
import { call, put } from 'redux-saga/effects'

import history from '../../../history'
import {
  BlogDetailInterface,
  CreateBlogInputInterface
} from '../../../interfaces/blog'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { createBlogSucceed, requestFailure } from '../actions'

export function* createBlogSaga(
  blogApi: {
    createBlog: (...args: any[]) => any
  },
  {
    payload: blogDetail
  }: {
    payload: CreateBlogInputInterface
  }
) {
  try {
    const { data }: { data: BlogDetailInterface } = yield call(
      blogApi.createBlog,
      blogDetail
    )
    yield put(createBlogSucceed(data))
    yield call(history.push, `/blog/${data.blogId}/edit`)
  }catch (error: unknown) {
    if (error && typeof error === 'object' && 'isAxiosError' in error) {
      yield handleUnAuthorizedError(error as AxiosError)
      yield put(requestFailure(error))
    } else {
      yield put(requestFailure(error))
    }
  }
}
